import React from 'react';
import { CardContent as MuiCardContent, CardContentProps } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledCardContent = styled(MuiCardContent)<CardContentProps>(
  ({ theme }) => ({
    paddingTop: theme.spacing(1),
  }),
);

const CardContent = React.forwardRef<HTMLDivElement, CardContentProps>(
  (props, ref) => {
    return <StyledCardContent ref={ref} {...props} />;
  },
);

CardContent.displayName = 'CardContent';

export default CardContent;
